import React from "react";

import { LocationActivityLog } from "../../../../models/LocationActivityLog";
import { LocationActivityTableRow } from "../Row";
import "./styles.scss";

interface ILocationActivityTableItemProps {
  data?: LocationActivityLog;
}

export const LocationActivityTableItem: React.FunctionComponent<
  ILocationActivityTableItemProps
> = ({ data }) => {
  return (
    <div className="location-activity-table-item">
      <LocationActivityTableRow isHeader={false} locationActivityLog={data} />
    </div>
  );
};
